import { render } from "./PaletteView.vue?vue&type=template&id=24b7bbf2&scoped=true&ts=true"
import script from "./PaletteView.vue?vue&type=script&lang=ts"
export * from "./PaletteView.vue?vue&type=script&lang=ts"

import "./PaletteView.vue?vue&type=style&index=0&id=24b7bbf2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b7bbf2"]])

export default __exports__